const init = () => {
    eventListeners();
    paginationListeners();
    observeUpdates();
};

const eventListeners = () => {
    const form = document.getElementById("event-search-form");
    const eventType = form.querySelectorAll('input[name="eventType"]');
    const eventRegion = form.querySelectorAll('input[name="eventRegion"]');
    const reset = form.querySelector("input.search-reset");

    form.addEventListener("submit", (e) => {
        e.preventDefault();

        const eventType = getEventType();
        const eventRegion = getRegionType();
        const search = getSearchValue();
        const params = {
            swppg: null,
            eventType: eventType,
            eventRegion: eventRegion,
            searchwp: search,
        };

        let urlParams = [];
        Object.entries(params).forEach(([key, value]) => {
            if (value !== null) {
                urlParams.push(`${key}=${value}`);
            }
        });
        const paramsString = urlParams.join("&");

        updateURL(buildURL(params));
        scrollToWrapper();

        sendToRest(rbEventsObject.rest_url + "snaplogic/v1/events", params).then(
            (data) => {
                updatePosts(data['data']);
                clearWrapperUpdatingStatus();
            }
        );
    });

    const onChangeFilters = () => {
        form.requestSubmit();
    };

    eventType.forEach((input) => {
        input.addEventListener("change", (e) => {
            onChangeFilters();
            return;
        });
    });

    eventRegion.forEach((input) => {
        input.addEventListener("change", (e) => {
            console.log(e);
            e.preventDefault();
            onChangeFilters();
            return;
        });
    });

    reset.addEventListener("click", (e) => {
        e.preventDefault();

        const params = {
            swppg: null,
            eventType: "all",
            searchwp: null,
        };

        document.querySelector('#event-search-form').reset();

        updateURL(buildURL(params));
        scrollToWrapper();

        sendToRest(rbEventsObject.rest_url + "snaplogic/v1/events", params).then(
            (data) => {
                updatePosts(data['data']);
                clearWrapperUpdatingStatus();
            }
        );
    });
};

const paginationListeners = () => {
    const pagination = document.querySelectorAll(".numbered-pagination a");

    pagination.forEach((link) => {
        link.addEventListener("click", (e) => {
            e.preventDefault();

            const eventType = getEventType();
            const eventRegion = getRegionType();
            const search = getSearchValue();
            const params = {
                swppg: getQueryParams("swppg", e.target.href),
                eventType: eventType,
                eventRegion: eventRegion,
                searchwp: search,
            };

            updateURL(link.href);
            scrollToWrapper();

            sendToRest(rbEventsObject.rest_url + "snaplogic/v1/events", params).then(
                (data) => {
                    updatePosts(data['data']);
                    clearWrapperUpdatingStatus();
                }
            );
        });
    });
};

const buildURL = (params) => {
    let urlParams = [];
    Object.entries(params).forEach(([key, value]) => {
        if (value !== null) {
            urlParams.push(`${key}=${value}`);
        }
    });
    const paramsString = urlParams.join("&");

    // Support Weglot translations 
    const currentLanguage = document.documentElement.lang;

    if ( currentLanguage && currentLanguage.includes('en') == false ) {
        return `${window.location.protocol}//${window.location.hostname}/${currentLanguage}/resources/events?${paramsString}`;
    } else {
        return `${window.location.protocol}//${window.location.hostname}/resources/events?${paramsString}`;
    }
};

const getEventType = () => {
    const radioElement = document.getElementsByName("eventType");
    let value = "";

    radioElement.forEach((el) => {
        if (el.checked) {
            value = el.value;
        }
    });

    return value;
};

const getRegionType = () => {
    const regionElement = document.getElementsByName("eventRegion");
    let value = [];
    regionElement.forEach((el) => {
        if (el.checked) {
            value.push(el.value);
        }
    });

    return value.join(",");
};

const getSearchValue = () => {
    const search = document.getElementById("event-search")?.value;
    return search;
};

const scrollToWrapper = () => {
    const wrapper = document.querySelector(".search-wrapper");
    window.scrollTo({
        behavior: "smooth",
        top:
            document.querySelector(".search-wrapper").getBoundingClientRect().top -
            document.body.getBoundingClientRect().top -
            100,
    });
    wrapper.classList.add("updating");
};

const clearWrapperUpdatingStatus = () => {
    const wrapper = document.querySelector(".search-wrapper");
    wrapper.classList.remove("updating");
};

const observeUpdates = () => {
    const target = document.querySelector(".search-wrapper");
    const config = {
        attributes: false,
        childList: true,
        subTree: true,
    };

    const callback = (mutationList, observer) => {
        for (const mutation of mutationList) {
            if (mutation.type === "childList") {
                paginationListeners();
            } else if (mutation.type === "subTree") {
                console.log("A sub tree node as been updated");
            }
        }
    };

    const observer = new MutationObserver(callback);

    observer.observe(target, config);
};

const updateURL = (url) => {
    const nextURL = url;
    const nextTitle = document.title;
    const nextState = {additionalInformation: "Updated the URL with JS"};

    window.history.replaceState(nextState, nextTitle, nextURL);
};

async function sendToRest(url = "", data = {}) {
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
    });
    return response.json();
}

const updatePosts = (data) => {
    const wrapper = document.querySelector(".search-wrapper");

    wrapper.innerHTML = data;
};

const getQueryParams = (params, url) => {
    let href = url;

    //this expression is to get the query strings
    let reg = new RegExp("[?&]" + params + "=([^&#]*)", "i");
    let queryString = reg.exec(href);

    return queryString ? queryString[1] : null;
};

window.addEventListener("DOMContentLoaded", () => {
    init();
});
